module.exports = __webpack_public_path__ + "img/YifanFeng.ea0c3a56.jpg";